import type { ValueConstructor } from '@/engine/DataFlow/DataFlow';
import type { IValue } from '@/engine/DataFlow/Graph';
import type * as DT from '../DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class BaseAlgorithmTuner<T, U extends DT.IWrapper<T> & IValue> {
  protected _planningAlgorithm: PlanningAlgorithm;

  private _constructor: ValueConstructor<U>;

  public constructor(planningAlgorithm: PlanningAlgorithm, constructor: ValueConstructor<U>) {
    this._planningAlgorithm = planningAlgorithm;
    this._constructor = constructor;
  }

  public getValue(name: string): T {
    return this._planningAlgorithm.getValueStrict(name, this._constructor).value;
  }

  public getValueSafe(name: string): T | undefined {
    return this._planningAlgorithm.getValue(name, this._constructor)?.value;
  }

  public async getValueAsync(name: string): Promise<T> {
    return (await this._planningAlgorithm.getValueStrictAsync(name, this._constructor)).value;
  }

  public async getValueSafeAsync(name: string): Promise<T | undefined> {
    return (await this._planningAlgorithm.getValueAsync(name, this._constructor))?.value;
  }

  public setValueAsync(name: string, value: T): Promise<void> {
    return this._planningAlgorithm.setTuneValuesAsync([[name, new this._constructor(value)]]);
  }
}
